export enum ScoringRole {
  LEAD = "lead",
  SELLER = "seller",
}

export enum ScoringTableType {
  AGGREGATED = "aggregated",
  DETAILED = "detailed",
}
export enum ScoringTabType {
  Users = "users",
  Catalogs = "catalogs",
  Categories = "categories",
  Segments = "segments",
}

export enum ScoringUserSegment {
  COLD_LEADS = "cold_leads",
  WARM_LEADS = "warm_leads",
  HOT_LEADS = "hot_leads",
  WEAK_SELLERS = "weak_sellers",
  ACTIVE_SELLERS = "active_sellers",
  VERY_ACTIVE_SELLERS = "very_active_sellers",
}

export function getTableTypeName(type: ScoringTableType): string {
  const types: Record<ScoringTableType, string> = {
    [ScoringTableType.AGGREGATED]: "Агрегированный",
    [ScoringTableType.DETAILED]: "Детализированный",
  };
  return types[type];
}

export function getScoringRoleName(role: ScoringRole): string {
  const types: Record<ScoringRole, string> = {
    [ScoringRole.LEAD]: "LEAD",
    [ScoringRole.SELLER]: "SELLER",
  };
  return types[role];
}

export function getScoringTabTypeName(tabType: ScoringTabType): string {
  const types: Record<ScoringTabType, string> = {
    [ScoringTabType.Users]: "Пользователи",
    [ScoringTabType.Catalogs]: "Подразделы",
    [ScoringTabType.Categories]: "Разделы",
    [ScoringTabType.Segments]: "Сегменты",
  };
  return types[tabType];
}

export function getScoringUserSegmentName(segment: ScoringUserSegment): string {
  const segments: Record<ScoringUserSegment, string> = {
    [ScoringUserSegment.COLD_LEADS]: "Холодный",
    [ScoringUserSegment.WARM_LEADS]: "Теплый",
    [ScoringUserSegment.HOT_LEADS]: "Горячий",
    [ScoringUserSegment.WEAK_SELLERS]: "Слабые продавцы",
    [ScoringUserSegment.ACTIVE_SELLERS]: "Активные продавцы",
    [ScoringUserSegment.VERY_ACTIVE_SELLERS]: "Очень активные продавцы",
  };
  return segments[segment];
}

export function getScoringUserSegmentFilter(
  segment: ScoringUserSegment
): string {
  const segments: Record<ScoringUserSegment, string> = {
    [ScoringUserSegment.COLD_LEADS]: "Холодные лиды",
    [ScoringUserSegment.WARM_LEADS]: "Средне заинтересованные лиды",
    [ScoringUserSegment.HOT_LEADS]: "Горячие лиды",
    [ScoringUserSegment.WEAK_SELLERS]: "Слабоактивные/новые продавцы",
    [ScoringUserSegment.ACTIVE_SELLERS]: "Активные продавцы",
    [ScoringUserSegment.VERY_ACTIVE_SELLERS]: "Очень активные продавцы",
  };
  return segments[segment];
}

export interface ScoringTableResponse {
  tableName: ScoringTabType;
  tableType: ScoringTableType;
  endpoint: string;
  isDefault: boolean;
}

export interface ScoringLeadsRequest {
  orderBy?: string | null;
  limit?: number;
  offset?: number;
  dateFrom?: string | null;
  dateTo?: string | null;
  userId?: string[];
  userSearch?: string | null;
  userRole?: ScoringRole[];
  userSegment?: ScoringUserSegment[];
  regCountryId?: string[];
  currentCountry?: string[];
  regCityId?: string[];
  currentCity?: string[];
  categoryId?: string[];
  catalogId?: string[];
  scoreFrom?: number | null;
  scoreTo?: number | null;
  viewsFrom?: number | null;
  viewsTo?: number | null;
  favoritesFrom?: number | null;
  favoritesTo?: number | null;
  messagesFrom?: number | null;
  messagesTo?: number | null;
  timeFrom?: number | null;
  timeTo?: number | null;
  activeAdsFrom?: number | null;
  activeAdsTo?: number | null;
  archivedAdsFrom?: number | null;
  archivedAdsTo?: number | null;
  totalUsersFrom?: number | null;
  totalUsersTo?: number | null;
  avgTimeFrom?: number | null;
  avgTimeTo?: number | null;
  sellersScoreFrom?: number | null;
  sellersScoreTo?: number | null;
  leadsScoreFrom?: number | null;
  leadsScoreTo?: number | null;
}
